import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    initialOpen: Boolean,
  };

  connect() {
    if (this.initialOpenValue) {
      this.element.showModal();
    }
  }

  close() {
    this.element.close();
  }
}
